import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export type PayflowTopBarPageStore = UseBoundStore<StoreApi<IPayflowTopBarSlice>>;

export interface IPayflowTopBarSlice {
  returnUrl: string | null;
  returnLabel: string | null;
}

export const createPayflowTopBarSliceDefaultValues = (): IPayflowTopBarSlice => ({
  returnUrl: null,
  returnLabel: null,
});

export const createPayflowTopBarSlice: StateCreator<IPayflowTopBarSlice> = () =>
  createPayflowTopBarSliceDefaultValues();

export const createPayflowTopBarHooks = (pageStore: PayflowTopBarPageStore) => ({
  useReturnUrl: () => pageStore((state) => state.returnUrl),
  useReturnLabel: () => pageStore((state) => state.returnLabel),
});

export type PayflowTopBarHooks = ReturnType<typeof createPayflowTopBarHooks>;
